const GOOGLE_MAPS_SCRIPT_ID = 'pontotel-google-maps-script'
const GOOGLE_MAPS_CALLBACK = 'pontotelGoogleMapsInit'

let loaderConfig = {
  load: {
    key: '',
    libraries: []
  }
}

let googleMapsPromise = null

const normalizarLibraries = (libraries = []) => {
  if (Array.isArray(libraries)) {
    return libraries.filter(Boolean)
  }

  if (typeof libraries === 'string') {
    return libraries.split(',').map((item) => item.trim()).filter(Boolean)
  }

  return []
}

const montarUrlDoScript = (load) => {
  const params = new URLSearchParams()
  const libraries = normalizarLibraries(load.libraries)

  Object.entries(load).forEach(([key, value]) => {
    if (key === 'libraries') {
      if (libraries.length) {
        params.set('libraries', libraries.join(','))
      }
      return
    }

    if (value === undefined || value === null || value === '') {
      return
    }

    const normalizedKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
    params.set(normalizedKey, String(value))
  })

  params.set('loading', 'async')
  params.set('callback', `google.maps.${GOOGLE_MAPS_CALLBACK}`)

  return `https://maps.googleapis.com/maps/api/js?${params.toString()}`
}

export const configureGoogleMapsLoader = (config = {}) => {
  const load = config.load || {}

  loaderConfig = {
    ...loaderConfig,
    ...config,
    load: {
      ...loaderConfig.load,
      ...load
    }
  }
}

export const loadGoogleMaps = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Google Maps loader requires a browser environment'))
  }

  if (window.google?.maps?.Map) {
    return Promise.resolve(window.google)
  }

  if (googleMapsPromise) {
    return googleMapsPromise
  }

  if (!loaderConfig.load?.key) {
    return Promise.reject(new Error('Google Maps API key is not configured'))
  }

  googleMapsPromise = new Promise((resolve, reject) => {
    const googleNamespace = window.google || (window.google = {})
    const mapsNamespace = googleNamespace.maps || (googleNamespace.maps = {})
    const existingScript = document.getElementById(GOOGLE_MAPS_SCRIPT_ID)

    if (typeof mapsNamespace.Map === 'function') {
      resolve(googleNamespace)
      return
    }

    const finalizeLoad = () => {
      delete window[GOOGLE_MAPS_CALLBACK]
      delete mapsNamespace[GOOGLE_MAPS_CALLBACK]
      resolve(googleNamespace)
    }

    const onError = () => {
      googleMapsPromise = null
      delete window[GOOGLE_MAPS_CALLBACK]
      delete mapsNamespace[GOOGLE_MAPS_CALLBACK]
      const script = document.getElementById(GOOGLE_MAPS_SCRIPT_ID)
      if (script?.parentNode) {
        script.parentNode.removeChild(script)
      }
      reject(new Error('Failed to load Google Maps API'))
    }

    window[GOOGLE_MAPS_CALLBACK] = finalizeLoad
    mapsNamespace[GOOGLE_MAPS_CALLBACK] = finalizeLoad

    if (existingScript) {
      if (typeof mapsNamespace.Map === 'function') {
        finalizeLoad()
        return
      }

      existingScript.addEventListener('error', onError, { once: true })
      return
    }

    const script = document.createElement('script')
    script.id = GOOGLE_MAPS_SCRIPT_ID
    script.async = true
    script.defer = true
    script.src = montarUrlDoScript(loaderConfig.load)
    script.addEventListener('error', onError, { once: true })
    document.head.appendChild(script)
  })

  return googleMapsPromise
}

export const getGoogleMapsNamespace = async () => {
  const google = await loadGoogleMaps()
  return google.maps
}
